"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikInput = void 0;
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var morse_react_1 = require("morse-react");
/**
 * A base component that exposes all the intrinsic form input components
 *
 * Prefer using the named variants e.g. FormikTextBox to reduce prop count and make
 * form designs more expressive.
 *
 * @param props
 * @returns
 */
var FormikInput = function (props) {
    var _a;
    var type = props.type !== 'textarea' ? (_a = props.type) !== null && _a !== void 0 ? _a : 'text' : props.type;
    var Component = type == 'textarea' ? morse_react_1.TextArea : morse_react_1.Input;
    return react_1.default.createElement(formik_1.FastField, { name: props.name, as: Component, type: type, validate: props.validate });
};
exports.FormikInput = FormikInput;
//# sourceMappingURL=FormikInput.js.map